
// NATIVE 
import { useEffect, useState } from 'react';

// INSTALLED 
import { useFormikContext } from 'formik';
import DeleteIcon from '@mui/icons-material/Delete';
import { useDispatch, useSelector } from 'react-redux';
import { Card, Divider, Grid, IconButton, Paper, Tooltip, Typography, Button } from '@mui/material';

// CUSTOM 
import InputField from 'components/formFields/InputField';
import InputNumeric from 'components/formFields/InputNumeric';
import { uploadPdfStore } from 'store/uploaders';
import { storeFamilyBeneficiarios, storeSizeFamily } from 'store/size_family';
import DatePickerField from 'components/formFields/datePickerField';
import AutocompleteField from 'components/formFields/autocompleteField';
import { UploadButtonField } from 'components/formFields/uploadButtonField';
import { LinearProgressWithLabel } from 'components/LinearProgressWithLabel';
import { PreviewPdfButton } from 'components/PreviewPdfButton';

export const DinamicFamilia = ( props : any) => {

  const { children, onOpenPdf } = props;



  // REDUX 
  // const { sizeFamilyBeneficiarios }: any = useSelector((state: any) => state.sizefamily);
  
  const dispatch = useDispatch();
  const formikProps: any = useFormikContext();

  const { sizefamily }: any = useSelector((state: any) => state.sizefamily);

  const  { type_documents_list_select } = useSelector( (state:any) => state.tipodocumento );

  const [percentage_upload_cc, setPercentageUploadCc] = useState(0);

  useEffect(() => {
    if (children > 0) {
      dispatch(storeSizeFamily(children));
    }
  }, [children]);

  const parentesco_list = [
    { label: 'conyuge', value: 'Cónyuge' },
    { label: 'hijo', value: 'Hijo' },
    { label: 'hijastro', value: 'Hijastro' },
    { label: 'padre', value: 'Padre' },
    { label: 'madre', value: 'Madre' },
  ];

  const genderList = [
    { label: 'masculino', value: 'masculino' },
    { label: 'femenino', value: 'Femenino' },
    { label: 'otro', value: 'otro' }
  ];

  const escolaridadList = [
    { label: 'primaria', value: 'primaria' },
    { label: 'bachillerato', value: 'bachillerato' },
    { label: 'tecnico', value: 'tecnico' },
    { label: 'tecnologo', value: 'tecnologo' },
    { label: 'postgrado', value: 'postgrado' },
  ];

  const uploadDocument = async ({ target }: any, index: number) => {
    const { ok, data } = await dispatch(
      uploadPdfStore('doc-beneficiario-empleado', target.files[0], setPercentageUploadCc)
    );

    if (ok) {
      const newFamily = [...formikProps.values.family];
      newFamily[index] = {
        ...newFamily[index],
        documento_beneficiario: data,
      };
      formikProps.setFieldValue('family', newFamily);
    }
  };


const { sizeFamilyBeneficiarios }: any = useSelector((state: any) => state.sizefamily);

  // const removeMember = async (index: number) => {
  //   if (
  //     Array.isArray(sizeFamilyBeneficiarios) &&
  //     sizeFamilyBeneficiarios.length > 0 &&
  //     index >= 0 &&
  //     index < sizeFamilyBeneficiarios.length
  //   ) {
  //     const currentFamily = [...formikProps.values.family]; // 🔹 Toma el estado actual
  //     currentFamily.splice(index, 1); // 🔹 Remueve del form actual
  //     formikProps.setFieldValue('family', currentFamily); // 🔹 Actualiza Formik
  //     await dispatch(storeFamilyBeneficiarios(currentFamily)); // 🔹 Opcional: actualiza Redux si necesitas
  //   }
  // };




  
  const removeMember = async (index: number) => {
    const currentFamily = [...formikProps.values.family]; // 🔹 Toma el estado actual de Formik
    currentFamily.splice(index, 1); // 🔹 Remueve el elemento en el índice dado
    
    formikProps.setFieldValue('family', currentFamily); // 🔹 Actualiza el estado de Formik
    await dispatch(storeFamilyBeneficiarios(currentFamily)); // 🔹 Actualiza Redux para que el renderizado sea consistente
  };

  return (
    <>
      {formikProps.values.family?.map((_: any, index: number) => (
        <Paper
          elevation={3}
          sx={{
            p: 5,
            mb: 4,
            borderRadius: 3,
            backgroundColor: '#fdfdfd',
            boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
          }}
          key={index}
        >
          <Grid container justifyContent="space-between" alignItems="center">
            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
              Beneficiario {index + 1}
            </Typography>
            <Tooltip title="Eliminar beneficiario" arrow>
              <IconButton color="error" onClick={() => removeMember(index)}>
                <DeleteIcon />
              </IconButton>
            </Tooltip>
          </Grid>

          <Divider sx={{ my: 2 }} />

          <Grid container spacing={2}>
            <Grid size={{ xs: 3, md: 3, sm: 6 }}>
              <AutocompleteField
                options={parentesco_list}
                name={`family[${index}].parentesco`}
                label={'Parentesco'}
                element={`family[${index}].parentesco`}
                required
              />
            </Grid>
            <Grid size={{ xs: 3, md: 3, sm: 6 }}>
              <AutocompleteField
                options={type_documents_list_select}
                name={`family[${index}].type_document`}
                label={'Tipo documento'}
                element={`family[${index}].type_document`}
                required
              />
            </Grid>
            <Grid size={{ xs: 3, md: 3, sm: 6 }}>
              <InputNumeric
                name={`family[${index}].num_document`}
                label={'Número documento'}
                required
                fullWidth
              />
            </Grid>
            <Grid size={{ xs: 3, md: 3, sm: 6 }}>
              <InputField
                name={`family[${index}].nombre`}
                label={'Nombre'}
                fullWidth
                required
              />
            </Grid>
            <Grid size={{ xs: 3, md: 3, sm: 6 }}>
              <InputField
                name={`family[${index}].apellido`}
                label={'Apellido'}
                required
                fullWidth
              />
            </Grid>
            <Grid size={{ xs: 3, md: 3, sm: 6 }}>
              <AutocompleteField
                options={genderList}
                name={`family[${index}].genero`}
                label={'Género'}
                element={`family[${index}].genero`}
                required
              />
            </Grid>
            <Grid size={{ xs: 3, md: 3, sm: 6 }}>
              <DatePickerField
                label={'Fecha nacimiento'}
                name={`family[${index}].fecha_nacimiento`}
                required
              />
            </Grid>
            <Grid size={{ xs: 3, md: 3, sm: 6 }}>
              <AutocompleteField
                options={escolaridadList}
                name={`family[${index}].escolaridad`}
                label={'Escolaridad'}
                element={`family[${index}].escolaridad`}
                required
              />
            </Grid>
            <Grid size={{ xs: 3, md: 3, sm: 6 }}>
              <InputField
                name={`family[${index}].ocupacion`}
                label={'Ocupación'}
                required
                fullWidth
              />
            </Grid>
            <Grid size={{ xs: 3, md: 3, sm: 6 }}>
              <UploadButtonField
                accept={'application/pdf'}
                name={`family[${index}].documento_beneficiario`}
                label={'Documento identidad'}
                text={'Documento identidad'}
                required={formikProps.values.family?.[index]?.documento_beneficiario ? false : true}
                onChange={(e: any) => uploadDocument(e, index)}
                style={{ width: '100%' }}
              />

              {formikProps.values.family?.[index]?.documento_beneficiario && (
                <Card variant="outlined" sx={{ mt: 1.5, p: 1 }}>
                  <LinearProgressWithLabel
                    percentage={
                      (typeof formikProps.values.family[index].documento_beneficiario === 'string' || formikProps.values.family[index].documento_beneficiario.pdfName || formikProps.values.family[index].documento_beneficiario.name) 
                        ? 100 : percentage_upload_cc
                    }
                    label={
                      typeof formikProps.values.family[index].documento_beneficiario === 'string'
                        ? 'Archivo cargado'
                        : (formikProps.values.family[index].documento_beneficiario.name || formikProps.values.family[index].documento_beneficiario.pdfName || 'Documento Identidad')
                    }
                    hasIcon={true}
                  />
                  <PreviewPdfButton 
                    fileName={
                      typeof formikProps.values.family[index].documento_beneficiario === 'string'
                        ? formikProps.values.family[index].documento_beneficiario
                        : (formikProps.values.family[index].documento_beneficiario.pdfName || formikProps.values.family[index].documento_beneficiario.name)
                    } 
                    typeUrl="doc-beneficiario-empleado" 
                    onOpenPdf={onOpenPdf} 
                  />
                </Card>
              )}
            </Grid>
          </Grid>
        </Paper>
      ))}
    </>
  );
};
